import React from 'react';
import { SingleMeetingPageType } from '../../../lib/api/custom-page.types';
import { SingleMeetingPageWrapper } from '../SingleMeetingWrapper/SingleMeetingPageWrapper';

export const SingleMeetingCustomPage: React.FunctionComponent<SingleMeetingPageType> = (props: SingleMeetingPageType): JSX.Element | null => {
  if (props) return <SingleMeetingPageWrapper {...props} />;
  return null;
};
